import React, { useState } from 'react'
import { QuestionInputProps } from '../../questionTypes'

const MAX_LENGTH = 2000
const WARN_THRESHOLD = 1800

export const FreeFormQuestion: React.FC<QuestionInputProps> = ({ question: { id: questionId }, value, onChange, readOnly = false }) => {
  const [charCount, setCharCount] = useState(value.length)

  const handleChange = (text: string): void => {
    setCharCount(text.length)
    onChange(text)
  }

  return (
    <div className='survey-response-question__freeform'>
      <textarea
        id={`question-${questionId}`}
        className='survey-response-question__textarea'
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        rows={4}
        placeholder='Type your response here...'
        maxLength={MAX_LENGTH}
        readOnly={readOnly}
      />
      <div className='survey-response-question__textarea-footer'>
        <span
          className={['survey-response-question__char-count', charCount > WARN_THRESHOLD && 'is-warn']
            .filter(Boolean)
            .join(' ')}
        >
          {charCount}/{MAX_LENGTH}
        </span>
      </div>
    </div>
  )
}
